export default __webpack_public_path__ + "static/media/react-logo.40e56194.png";